// web/src/tutorial/l.ts
// 教程内容编写用的小工具：双语文案的简写构造。

import type { LocalizedText } from "./types";

export function l(zh: string, en: string): LocalizedText {
  return { zh, en };
}
